import * as Yup from "yup";


const initValuesArticle = {
    period: "",
    codeOrganizational: "",
    description: "",
    distrUnit: "",
    unitCost: "",
    currentValue: "",
    staticArticle: false,
    category: "",
    distrUnitQuantity: "",
    staticArticleCode: "",
    minimunStock: ""
}

const validationSchemaArticle = Yup.object().shape({
    period: Yup.date().required('Por favor selecciona la fecha de adquisición de soporte.'),
    codeOrganizational: Yup.string(),
    description: Yup.string().required("Por favor agrega el nombre del item."),
    distrUnit: Yup.string().required("Por favor agrega el tipo de distribución del item."),
    unitCost: Yup.number().positive("El costo unitario debe ser un número positivo.").required("Por favor el costo unitario del item."),
    distrUnitQuantity: Yup.number().positive("La cantidad debe ser un número positivo.").required("Por favor agregar la cantidad del item por presentación."),
    currentValue: Yup.number().positive("El costo actual debe ser un número positivo.").required("Por favor el costo actual del item."),
    staticArticle: Yup.boolean().nullable().default(false),
    staticArticleCode: Yup.string().when("staticArticle", {
        is: true,
        then: (schema) => schema.required("El código de activo fijo es obligatorio."),
        otherwise: (schema) => schema.notRequired(),
    }),
    category: Yup.string().required("Por favor agrega la categoría del item."),
    minimunStock: Yup.number()
});


export { initValuesArticle, validationSchemaArticle }